import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import {BASE_CLASS_NAME} from '../../config.js'

const LoaderSpinnerSellerPlate = ({loader}) => {
  const {i18n} = useContext(Context)
  return (
    <>
      {loader}
      <div className={`${BASE_CLASS_NAME}-loaderText`}>{i18n.t('PUBLISH_AD.WITH_PLATE.SEARCHING_DATA')}</div>
    </>
  )
}

LoaderSpinnerSellerPlate.displayName = 'LoaderSpinnerSellerPlate'
LoaderSpinnerSellerPlate.propTypes = {
  loader: PropTypes.elementType
}

export default LoaderSpinnerSellerPlate
